import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { PosUtilityService } from '../../pos-services/pos-utility.service';
import { KeyboardService } from '../../../../shared/keyboard/keyboard.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'pos-teclado-virtual',
  template: `
    <div cdkDragBoundary="#pos-home-wrapper" cdkDrag class="shadow  pb-3 mb-5 pos-teclado-alfa">
      <div class="relative">
        <div class=" p-1 pos-teclado-header bg-secondary" cdkDragHandle>
          <div  class="absolute right-0 top-0 pt-02">
            <button type="button" (click)="fecharTeclado()" class="bg-secondary" ><mat-icon>close</mat-icon></button>
          </div>
          <div class="text-white">
            Teclado virtual
          </div>
        </div>

        <div class="pos-teclado-body">
          <app-keyboard  [tipoTeclado]="tecladoActivo"></app-keyboard>
        </div>

      </div>
    </div>


  `,
// tslint:disable-next-line:component-class-suffix
}) export class PosTecladoVirtual {
  @Output() aoDeletar = new EventEmitter();
  @Output() aoPressTecla = new EventEmitter();
  @Output() aoResetar = new EventEmitter();
  @Output() aoFechar = new EventEmitter();
  @Input() inputHTMLActual: HTMLInputElement;
  @Input() tecladoLivre: boolean = true;
  @Input() tecladoActivo: any  = {
    numerico: false,
    alpha: true
  };

  protected capsLockActiva = false;
  constructor(public posUtilityService: PosUtilityService, public keyboard: KeyboardService) {
  }
fecharTeclado(){
    this.posUtilityService.mostrarTecladoAlpha$.next(false);
}

}
